module.exports = __webpack_public_path__ + "static/media/view1.97d93ce4.jpg";